export default function() {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  // Initialize the video widget
  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${widgetName}`).videoWidget({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    maxVideos: 1,
    autoPlayVideo: false,
    loopVideo: true,
    showControls: true,

    videoWidgetLoaded: function(data) {
      // Initial check after widget is loaded
      checkVideoDataAndRemove();
      
      // Additional check after a short delay
      setTimeout(() => {
        checkVideoDataAndRemove();
      }, 1000); // Adjust timeout if needed
    }
  });

  function checkVideoDataAndRemove() {
    const videoWidget = $(`#${widgetName}`);
    const threeRightElements = $('.three-right');

    // Check if video data is available and if the iframe source is set
    const hasVideoData = videoWidget.data('video') && videoWidget.data('video').length > 0;
    const iframeSrcSet = videoWidget.find('iframe').attr('src') !== undefined;

    // Only remove .three-right if there is no video data and iframe source is not set
    if (!hasVideoData && !iframeSrcSet) {
      threeRightElements.remove();
    }
  }
}
